(function() {
    function funcReady() {
        $('.KRC0029').buildCommonUI();

        vcui.require(['ui/carousel'], function () {
            $('.KRC0029').find('.ui_carousel_slider').vcCarousel({
                infinite: false,
                autoplay: false,
                swipeToSlide: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow:'.btn-arrow.prev',
                nextArrow:'.btn-arrow.next',
                playSelector: '.btn-play.play',
                adaptiveHeight: true,
                lazyLoad: 'anticipated' //수정 jsw
            });
        });
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'CONTENTS', name: 'KRC0029', isFirstLoad: false, fn: function () {
                if(!document.querySelector('.KRC0029')) return false;
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(window).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRC0029')) return false;
        funcReady();
    });
})();

